import React, { useEffect, useState } from 'react';
import i18n from '@i18n';
import { LinearProgress, Grid } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { useAnalisis, usePresupuestos, useFacturacion } from '@hooks';
import { Divider, PieChart } from '@components/atoms';
import { WelcomeBoard } from '@components/molecules';
import { getColors } from '@helpers/utils';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import Filtros from '../Reporteria/Filtros';

const Dashboard = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { pages: { employees: { dashboard: texts } } } = i18n;
  const { getPresupuestoCount, isPresupuestoLoading } = usePresupuestos();
  const { getFacturacionCount, isFacturacionLoading } = useFacturacion();
  const { getAnalisisCount, isAnalisisLoading } = useAnalisis();

  const [presupuesto, setPresupuesto] = useState({ name: 'Presupuestos', data: null });
  const [facturacion, setFacturacion] = useState({ name: 'Informes', data: null });
  const [analisis, setAnalisis] = useState({ name: 'Ingresos', data: null });
  const [presupuestoColors, setPresupuestoColors] = useState([]);
  const [facturacionColors, setFacturacionColors] = useState([]);
  const [analisisColors, setAnalisisColors] = useState([]);
  const [filters, setFilters] = useState({
    dateInit: moment().startOf('year').format('YYYY-MM-DD'),
    dateEnd: moment().format('YYYY-MM-DD'),
    all: false,
    archivados: false,
    generate: false,
  });

  useEffect(async () => {
    const result = await Promise.allSettled([getPresupuestoCount(filters), getFacturacionCount(filters), getAnalisisCount(filters)]);
    if (result.map((r) => r.status).includes('rejected')) {
      enqueueSnackbar('Error en obtener datos', { variant: 'error' });
      return;
    }
    setPresupuesto({ ...presupuesto, data: result[0].value });
    setFacturacion({ ...facturacion, data: result[1].value });
    setAnalisis({ ...analisis, data: result[2].value });

    enqueueSnackbar(texts.form.success, { variant: 'success' });
    setFilters({ ...filters, generate: false });
  }, [filters.generate]);

  useEffect(async () => {
    const availableColors = presupuesto.data ? presupuesto.data.items.map((item) => getColors.getColorPresupuesto(item.name)) : [];
    setPresupuestoColors(availableColors);
  }, [presupuesto]);

  useEffect(async () => {
    const availableColors = facturacion.data ? facturacion.data.items.map((item) => getColors.getColorFacturacion(item.id)) : [];
    setFacturacionColors(availableColors);
  }, [facturacion]);

  useEffect(async () => {
    const availableColors = analisis.data ? analisis.data.items.map((item) => getColors.getColorAnalisis(item.id)) : [];
    setAnalisisColors(availableColors);
  }, [analisis]);

  return (
    <>
      <Helmet>
        <title>{`${i18n.appName} - ${texts.title}`}</title>
      </Helmet>
      { (isAnalisisLoading || isPresupuestoLoading || isFacturacionLoading)
        ? <LinearProgress />
        : (
          <>
            <Filtros filters={filters} setFilters={setFilters} showArchived={false} />
            <WelcomeBoard
              facturacion={facturacion}
              presupuesto={presupuesto}
              analisis={analisis}
            />
            <Divider />
            <Grid container spacing={3} justifyContent="space-around">
              {presupuesto && presupuesto.data && <PieChart data={presupuesto} backgroundColor={presupuestoColors} />}
              {analisis && analisis.data && <PieChart data={analisis} backgroundColor={analisisColors} />}
              {facturacion && facturacion.data && <PieChart data={facturacion} backgroundColor={facturacionColors} />}
            </Grid>
          </>
        )}
    </>
  );
};

export default Dashboard;
